import { render, staticRenderFns } from "./widget-version.vue?vue&type=template&id=670e77b2&scoped=true"
import script from "./widget-version.vue?vue&type=script&lang=js"
export * from "./widget-version.vue?vue&type=script&lang=js"
import style0 from "./widget-version.vue?vue&type=style&index=0&id=670e77b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e77b2",
  null
  
)

export default component.exports